module.exports = require('./src/google-maps-api-loader.js');